import { CommonError } from '@common/models/error.model';
import { AUTH_SERVICE } from '@common/services/auth/auth.service.interface';
import appStore from '@input-web/app/store/store.app';
import { useTranslation } from '@input-web/configs/locale/locale.config';
import mainStore from '@input-web/modules/main/stores/main.store';
import { useMutation } from '@tanstack/react-query';
import { useCallback } from 'react';
import { container } from 'tsyringe';

/**
 * Hook for handling user logout functionality
 * Manages logout mutation and app state reset
 * @returns Object containing logout handler
 */
export default function useLogoutMutation() {
  // #region Dependencies
  const { t } = useTranslation();
  // #endregion

  // #region Mutations
  const { mutate } = useMutation({
    mutationFn: container.resolve(AUTH_SERVICE).logout,
    onSuccess: () => appStore.actions.reset(),
  });
  // #endregion

  // #region Handlers
  const handleLogout = useCallback(() => mutate(undefined), [mutate]);
  const handleUnauthorizedLogout = useCallback(
    () =>
      mutate(undefined, {
        onSuccess: () => {
          mainStore.actions.addError(new CommonError({ message: t('error.unauthorized') }));
        },
      }),
    [mutate, t],
  );
  // #endregion

  return { handleLogout, handleUnauthorizedLogout };
}
